import { useQuery } from '@tanstack/react-query'

import { getUrlIntegration } from '@/services/get-url-integration'

export const GET_URL_INTEGRATION_QUERY = 'GET_URL_INTEGRATION'

interface UseGetUrlIntegrationProps {
  enabled: boolean
}

export const useGetUrlIntegration = ({
  enabled,
}: UseGetUrlIntegrationProps) => {
  const query = useQuery({
    queryKey: [GET_URL_INTEGRATION_QUERY],
    queryFn: ({ signal }) => getUrlIntegration({ signal }),
    enabled,
  })

  return query
}
